import { parsePhoneNumberFromString } from 'libphonenumber-js/min';
import { createPhoneMatchKey } from '../../../shared/phone-identity';
export const phoneMatchKey = createPhoneMatchKey(parsePhoneNumberFromString);
export function findContactByPhone(contacts, value) {
    const key = phoneMatchKey(value);
    if (!key)
        return undefined;
    const matches = contacts.filter(contact => phoneMatchKey(contact.phoneNumber) === key);
    const linked = matches.filter(contact => contact.linkedClientId);
    // Saved rows can be stale or duplicated. A number alone cannot choose
    // between two different platform accounts; let the directory resolve it.
    if (new Set(linked.map(contact => contact.linkedClientId)).size > 1)
        return undefined;
    return linked[0] || matches[0];
}
